<template>
  <div>
    <div v-if="loanProductsLoading"
      style="display: flex; top: 0px; position: fixed; left: 0px; right: 0px; bottom: 0px; background-color: rgba(247, 247, 247, 0.9); z-index: 9999; justify-content: center; align-items: center;">
      <div>
        <div>
          <h3>Getting Loans ready...</h3>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h1 class="mb-2 font-regular">Collection History</h1>
    </div>
    <div class="row">
      <div class="col-md-12" v-if="kpiObj !== null">
        <div class="card">
          <div class="card-body">
            <div class="row justify-content-around">
              <!-- order -->
              <div class="col-xl-4 col-lg-4 col-12 px--5 shadow rounded-1 mt-1" style="padding: 0.7rem;">
                <div class="d-flex justify-content-between">
                  <div>
                    <h2>KPI/<span style="font-size: 17px">Order</span></h2>
                  </div>
                  <div>
                    <ClipboardIcon />
                  </div>
                </div>
                <KeyValue objKey="Allocated Order" :objValue="kpiObj.allocated_loans" :showBullet="true" />
                <KeyValue objKey="Completed Order" :objValue="kpiObj.completed_loans" :showBullet="true" />
                <KeyValue objKey="Total Assigned Case" :objValue="kpiObj.total_assigned_cases" :showBullet="true" />
                <KeyValue objKey="Overdue Loans" :objValue="kpiObj.overdue_loans" :showBullet="true" />
                <KeyValue objKey="Loans Not Overdue" :objValue="kpiObj.loans_not_overdue" :showBullet="true" />
                <KeyValue objKey="Delegated Amount" :objValue="kpiObj.delegated_amount" :showBullet="true" />
                <KeyValue objKey="Recovered Amount" :objValue="kpiObj.recovered_amount" :showBullet="true" />
              </div>
              <div class="col-xl-4 col-lg-4 col-12 px--5 shadow rounded-1 mt-1" style="padding: 0.7rem;">
                <div class="d-flex justify-content-between">
                  <div>
                    <h2>Call Rate<span style="font-size: 17px"></span></h2>
                  </div>
                  <div>
                    <ClipboardIcon />
                  </div>
                </div>
                <KeyValue objKey="All Call Rate" :objValue="kpiObj.all_call_rate" :showBullet="true" />
                <KeyValue objKey="Call Rate Today" :objValue="kpiObj.call_rate_today" :showBullet="true" />
                <KeyValue objKey="Call Rate This Week" :objValue="kpiObj.call_rate_this_week" :showBullet="true" />
                <KeyValue objKey="Call Rate This Month" :objValue="kpiObj.call_rate_this_month" :showBullet="true" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="col-md-12">
        <div class="card card--no-shadow card-profile">
          <div class="card-header">
            <h3 class="font-weight-600 mb-0">Filter Loan Report</h3>
          </div>
          <div class="card-content">
            <div class="card-body">
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="">BVN</label>
                    <input type="text" @keypress="isNumber($event)" class="form-control" v-model="bvn"
                      placeholder="11111111111" maxlength="11" />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="">phone</label>
                    <input type="text" @keypress="isNumber($event)" class="form-control" v-model="phone"
                      placeholder="08012345678" maxlength="13" />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="">Reference</label>
                    <input type="text" class="form-control" placeholder="83IJDK2DHEU" v-model="ref" />
                  </div>
                </div>

                <div class="col-md-3">
                  <button @click.prevent="allProductLoan(1)" class="button w-100 mt-2" :disabled="reportsLoading">
                    <span class="custom-loader" v-if="reportsLoading">
                      <loader-icon size="1.5x" class="custom-class"></loader-icon>
                      <span style="font-weight: 600; text-transform: initial;">Fetching Loan Data...</span>
                    </span>
                    <span v-else>
                      Filter
                    </span>
                  </button>
                  <!-- </div>
                    </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="card p-2">
          <div class="card-content">
            <div class="card body p-md-3 p-2">
              <CDataTable :items="loanProducts" :fields="fields" sorter>
                <!-- <template #name="{item}">
                    <td>
                      {{ `${item.user.first_name} ${item.user.last_name}` }}
                    </td>
                  </template> -->
                <!-- <template #phone="{item}">
                    <td>
                      {{ item.user.phone_number }}
                    </td>
                  </template>
                  <template #bvn="{item}">
                    <td>
                      {{ item.user.kyc.bvn }}
                    </td>
                  </template> -->
                <template #created_at="{ item }">
                  <td>
                    {{ item.created_at | date }}
                  </td>
                </template>
                <template #last_repayment_date="{ item }">
                  <td>
                    {{ item.last_repayment_date | date }}
                  </td>
                </template>
                <template #due_date="{ item }">
                  <td>
                    {{ item.due_date | date }}
                  </td>
                </template>
                <template #last_collection_action="{ item }">
                  <td>
                    <div v-if="item.last_collection">
                      {{ item.last_collection.collection_result }}<br>
                      {{ item.last_collection.collection_details }}<br>
                      {{ item.last_collection.collection_object_name }}<br>
                      {{ item.last_collection.created_at | date }}<br>
                    </div>
                  </td>
                </template>
                <template #action="{ item }">
                  <td>
                    <router-link v-if="permissions.includes('view-instant-loan')" :to="{
                      name: 'LoanComponent',
                      params: { slug: item.instant_reference }
                    }" class="button">
                      View</router-link>
                  </td>
                </template>
                <template #particulars="{ item }">
                  <td>
                    <b> {{ `${item.user.first_name} ${item.user.last_name}` }}</b>
                    <b>{{ item.user.phone_number }}</b><br>
                    <b>{{ item.user.kyc.bvn }}</b>
                  </td>
                </template>
              </CDataTable>
              <CPagination :activePage.sync="next_page" :pages="total" :onActivePageChange="onPageChange()">
              </CPagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueDataTable from "@/components/VueDataTable";
// import { mapGetters } from "vuex";
import CCard from "@/components/CCard";
import CModal from "@/components/CModal";
import CDataTable from "../../components/CDataTable.vue";
import ApiService from "@/services/api.service";
// import Swal from "sweetalert2";
// import ErrorService from "@/services/error.service";
import CPagination from "../../components/CPagination.vue";
import KeyValue from "@/components/KeyValue.vue";
// import { ClipboardIcon, CreditCardIcon } from "vue-feather-icons";
// let currentTab = 0;
const fields = [
  "action",
  "particulars",
  "instant_reference",
  "last_collection_action",
  "created_at",
  "last_repayment_date",
  "no_of_overdue_days",
  "loan_status",
  "tenure",
  "remaining_balance",
  "due_date",
];

export default {
  components: {
    VueDataTable,
    KeyValue,
    // ClipboardIcon,
    CCard,
    CModal,
    CDataTable,
    CPagination
    // CreditCardIcon
  },
  computed: {
    permissions() {
      let permissions = this.$store.getters.permissions;
      return permissions;
    },
    // ...mapGetters(["reportsLoading"]),
    removeCommaFromAmount() {
      return this.loan_amount.toString().replace(/,/g, "");
    }
  },
  data() {
    return {
      fields,
      loanProductsLoading: true,
      loanProducts: [],
      end_date: "",
      start_date: "",
      customer_id: "",
      loan_product: "",
      next_page: 1,
      total: 1,
      current: 1,
      reference: "",
      bvn: "",
      phone: "",
      ref: "",
      status: "",
      reportsLoading: true,
      kpiObj: null,
      kpiLoading: false,
    };
  },
  methods: {
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    async kpiStats() {
      try {
        this.kpiLoading = true;
        const res = await ApiService.get("loan/instant/collection_history_stats");

        this.kpiObj = res.data.data;
        this.kpiLoading = false;
      } catch (error) {
        this.kpiLoading = false;

        console.log(error.response);
      }
    },
    async allProductLoan(page) {
      this.reportsLoading = true;

      try {
        const response = await ApiService.get(
          `loan/instant/collection-history?page=${page}&instant_reference=${this.ref}&phone=${this.phone}&bvn=${this.bvn}`
        );
        console.log(response);
        this.loanProducts = response.data.data.data;
        this.current = response.data.data.current_page;
        this.total = response.data.data.last_page;
        this.loanProductsLoading = false;
        this.reportsLoading = false;
      } catch (error) {
        console.log(error.response);
        this.loanProductsLoading = false;
        this.reportsLoading = false;
      } finally {
        this.loanProductsLoading = false;
        this.reportsLoading = false;
      }
    },
    onPageChange() {
      console.log(this.next_page);
      if (this.current != this.next_page) {
        this.allProductLoan(this.next_page);
      }
    }
  },
  mounted() {
    this.allProductLoan(1);
    this.kpiStats();
  }
};
</script>

<style>
/* Hide all steps by default: */
.step-panel {
  display: none;
}
</style>